import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { InvitationProvider } from "./contexts/InvitationContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Login from "./components/Login";
import GuestPage from "./pages/GuestPage";
import AdminPage from "./pages/AdminPage";
import Navigation from "./components/Navigation";
import { ProtectedAdminRoute } from "./navigation";
import "./styles/index.css";

const AppContent: React.FC = () => {
  const { user } = useAuth();

  return (
    <Router>
      <div className="App">
        {user && <Navigation />}
        <main className="container">
          <Routes>
            {/* Guest routes */}
            <Route path="/" element={<GuestPage />} />

            {/* Admin routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <AdminPage />
                </ProtectedAdminRoute>
              }
            />

            {/* Redirect admin login to admin area */}
            <Route
              path="/login"
              element={<Navigate to="/admin/login" replace />}
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <InvitationProvider>
          <AppContent />
        </InvitationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
